<script>
import { required } from 'vuelidate/lib/validators'

import axios from 'axios'


export default {
	props: {
		url: {
			type: String,
			default: '/pan/xdr/indicators?exclude=intelligence&limit=999',
		}
	},
	data() {
		return {
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Indicators View',
					active: true,
				},
			],
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			incidents: [],
			tableData: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: 'reputation',
			sortDesc: true,
			fields: [
				{ key: 'kind', sortable: true },
				{ key: 'indicator', label: 'Indicator', sortable: true },
				{ key: 'reputation', sortable: true },
				{ key: 'incidents', sortable: true },
				// { key: 'alerts', sortable: true },
				// { key: 'last_update', sortable: true },
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		rows() {
			return this.tableData.length
		},
	},
	mounted () {
		this.loadData()
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		loadData () {
			let that = this
			that.isBusy = true
			// if (process.env.NODE_ENV === 'production' && that.$store.state.idToken === undefined) return
			let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
			// let headers = {
			// 	"Authorization": that.$store.state.id_token
			// }
			// axios.get(`${baseURL}${that.url}`, { headers: headers }).then((response) => {
			axios.get(`${baseURL}${that.url}`).then((response) => {
			  console.log(response.data)
				if (response.status === 200) {
					that.tableData = response.data.map(function(entry){
						// console.log('entry',entry)
						return {
							kind: entry.kind,
							indicator: entry.indicator !== undefined ? entry.indicator : null,
							network_remote_ip: entry.network_remote_ip !== undefined ? entry.network_remote_ip : null,
							file_sha256: entry.file_sha256 !== undefined ? entry.file_sha256 : null,
							reputation: entry.reputation,
							incidents: entry.incidents !== undefined ? entry.incidents : [],
							// incidents_high: entry.incidents_high !== undefined ? entry.incidents_high.length : 0,
							// incidents_medium: entry.incidents_medium !== undefined ? entry.incidents_medium.length : 0,
							// incidents_low: entry.incidents_low !== undefined ? entry.incidents_low.length : 0,
							// alerts: entry.alerts !== undefined ? entry.alerts.length : 0,
							// alerts_high: entry.alerts_high !== undefined ? entry.alerts_high.length : 0,
							// alerts_medium: entry.alerts_medium !== undefined ? entry.alerts_medium.length : 0,
							// alerts_low: entry.alerts_low !== undefined ? entry.alerts_low.length : 0,
							// last_update: new Date(entry.last_update['$date']).toLocaleString(),
						}
					})
					that.totalRows = that.tableData.length
				}
				that.isBusy = false
			})
			.catch(function (error) {

			}) 
			that.totalRows = that.tableData.length
		},
	},
}
</script>

<template>
	<div>
		<div class="row mb-md-2">
			<div class="col-sm-6 col-md-6">
				<span>
					Found: 
					<b>
						{{ totalRows }}
					</b>
					at
					<b>
						{{ new Date().toLocaleString() }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						Search:
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="perPage"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:filter="filter"
				:filter-included-fields="filterOn"
				@filtered="onFiltered"
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>
				<template v-slot:cell(kind)="data">
					<template v-if="data.item.kind === 'hash'">
						<feather type="file" class="icon-xs icon-dual"></feather>
					</template>
					<template v-else-if="data.item.kind === 'ip'">
						<feather type="cloud" class="icon-xs icon-dual"></feather>
					</template>
				</template>
				<template v-slot:cell(indicator)="data">
					{{ data.item.indicator || "N/A"}}
				</template>
				<template v-slot:cell(incidents)="data">
          <template v-for="incident in data.item.incidents">
            <span class="badge badge-secondary">
              {{ incident }}
            </span>
            &nbsp;
          </template>
				</template>
				<template v-slot:cell(alerts)="data">
					<span class="badge badge-secondary">
						{{ data.item.alerts }}
					</span>
					<span>
						=
					</span>
					<span class="badge badge-danger">
						{{ data.item.alerts_high }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-warning">
						{{ data.item.alerts_medium }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-success">
						{{ data.item.alerts_low }}
					</span>
				</template>
				<template v-slot:cell(action)="data">
					<span>ℹ️</span>
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<div id="tickets-table_length" class="dataTables_length">
					<label class="d-inline-flex align-items-center">
						Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination pagination-rounded mb-0">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
